import Vue from 'vue';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import Vuelidate from 'vuelidate';
import Toasted from 'vue-toasted';
import App from './App.vue';
import router from './router';
import store from './store';

import constMessages from './global/consts';

Vue.config.productionTip = false;

Vue.use(Vuelidate);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);

Vue.prototype.$consts = constMessages;

Vue.use(Toasted, {
  theme: 'bubble',
  duration: 2000,
  singleton: true,
  position: 'top-center',
});

Vue.toasted.register('error',
  (payload) => payload.message,
  {
    type: 'error',
  });

Vue.toasted.register('success',
  (payload) => payload.message,
  {
    type: 'success',
  });

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
